import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers } from 'recompose';
import { ChevronRight } from 'components/svg';
import { Link } from 'components/core/Link';
import { setLocation } from 'lib/helpers';
import UnitDetails from './UnitDetails';

import './LinkedUnitDetails.scss';

const enhance = compose(
	withHandlers({
		routeToLinkedUnit: () => (route) => {
			setLocation(route);
		},
	})
);

export function LinkedUnitDetails({ unit, routeToLinkedUnit, facility, showIcon }) {
	return (
		<Link
			hideBorder
			className="linked-unit-details"
			href={unit.facilityUrl}
			onClick={() => routeToLinkedUnit(unit.facilityUrl || unit.url)}
			productClick
		>
			<UnitDetails
				unit={unit}
				facility={{
					showFeeWarning: facility?.showFeeWarning,
					fees: facility?.fees,
					giftCardOffer: facility?.giftCardOffer,
					url: facility?.url?.facility,
				}}
				showIcon={showIcon}
			/>

			<ChevronRight />
		</Link>
	);
}

LinkedUnitDetails.propTypes = {
	unit: PropTypes.shape({
		facilityUrl: PropTypes.string,
		url: PropTypes.string,
		width: PropTypes.number,
		length: PropTypes.number,
		sizeBucket: PropTypes.string,
		unitTypeText: PropTypes.string,
		unitId: PropTypes.number,
	}),
	routeToLinkedUnit: PropTypes.func,
	facilityUrl: PropTypes.string,
	facility: PropTypes.object,
	showIcon: PropTypes.bool
};

export default enhance(LinkedUnitDetails);
